import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import commonJa from './locales/ja/common.json';
import homeJa from './locales/ja/home.json';
import scheduleJa from './locales/ja/schedule.json';
import coachesJa from './locales/ja/coaches.json';
import faqJa from './locales/ja/faq.json';
import pricingJa from './locales/ja/pricing.json';

import commonEn from './locales/en/common.json';
import homeEn from './locales/en/home.json';
import scheduleEn from './locales/en/schedule.json';
import coachesEn from './locales/en/coaches.json';
import faqEn from './locales/en/faq.json';
import pricingEn from './locales/en/pricing.json';

import commonPt from './locales/pt/common.json';
import homePt from './locales/pt/home.json';
import schedulePt from './locales/pt/schedule.json';
import coachesPt from './locales/pt/coaches.json';
import faqPt from './locales/pt/faq.json';
import pricingPt from './locales/pt/pricing.json';

const savedLang = localStorage.getItem('bjjcore-lang') || 'ja';

i18n.use(initReactI18next).init({
  resources: {
    ja: {
      common: commonJa,
      home: homeJa,
      schedule: scheduleJa,
      coaches: coachesJa,
      faq: faqJa,
      pricing: pricingJa,
    },
    en: {
      common: commonEn,
      home: homeEn,
      schedule: scheduleEn,
      coaches: coachesEn,
      faq: faqEn,
      pricing: pricingEn,
    },
    pt: {
      common: commonPt,
      home: homePt,
      schedule: schedulePt,
      coaches: coachesPt,
      faq: faqPt,
      pricing: pricingPt,
    },
  },
  lng: savedLang,
  fallbackLng: 'ja',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
